var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"caja-anuncio"},[_c('div',{staticClass:"anuncio"},[_c('i',{staticClass:"fas fa-bell campana"}),_vm._v(" "),_c('router-link',{staticClass:"parpadea",attrs:{"to":"/Web/NotificacionEdictos"}},[_vm._v(" Nuevos Edictos Juzgados Laborales y Familiar ")])],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7c994b4e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PaginaOficial/Comun/MenuSuperior/MenuAnuncios.vue
// module id = null
// module chunks = 